<script>
import Repositories from '@/repositories';
const WorkOrderItemsRepository = Repositories.get('workorderitems');
import dateMixin from '@/mixins/dateMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

/**
 * Dashboard Component
 */
export default {
  components: {
    Loading,
  },
  props: {
    itemIdPublic: String,
  },
  data() {
    return {
      isLoading: false,
      woItemsList: [],
    };
  },
  created() {
    this.loadData();
  },
  mixins: [dateMixin],
  methods: {
    loadData() {
      this.woItemsList = [];
      if (this.itemIdPublic != null) {
        this.isLoading = true;

        WorkOrderItemsRepository.customREST
          .getReservedByItem(this.itemIdPublic)
          .then((response) => {
            this.woItemsList = response.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isLoading = false;
          });
      }
    },
    requestInstead(idPublic) {
      this.changeReservation(idPublic, true);
    },
    cancelReservation(idPublic) {
      this.changeReservation(idPublic, false);
    },
    changeReservation(idPublic, requestInstead) {
      this.isLoading = true;
      WorkOrderItemsRepository.actions
        .cancelReservation({ requestInstead: requestInstead }, idPublic)
        .then(() => {
          let foundIndex = this.woItemsList.findIndex(
            (x) => x.idPublic == idPublic
          );

          this.$emit('removed-woitem', this.woItemsList[foundIndex]);

          this.woItemsList.splice(foundIndex, 1);

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgainBulk'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
          this.loadData();
        });
    },
  },
  computed: {
    reservedSum() {
      return this.woItemsList.reduce(function (prev, cur) {
        return prev + cur.reservedQuantity;
      }, 0);
    },
  },
};
</script>

<template>
  <b-container class="p-0" fluid>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <b-row>
      <b-col>
        <h5>{{ $t('items.reservations') + ` (${reservedSum})` }}</h5>
      </b-col>
    </b-row>
    <b-row class="custom-grid-header no-gutters">
      <b-col cols="6" class="custom-grid-header-column">
        {{ $t('workOrders.workOrder') }}
      </b-col>
      <b-col cols="2" class="custom-grid-header-column text-center">
        {{ $t('items.quantity') }}
      </b-col>
      <b-col cols="3" class="custom-grid-header-column text-center">
        {{ $t('general.deliveryDate') }}
      </b-col>
      <b-col cols="1" class="custom-grid-header-column text-center">
        {{ $t('general.action') }}
      </b-col>
    </b-row>

    <b-row
      v-for="woItem in woItemsList"
      :key="woItem.idPublic"
      class="custom-grid-row no-gutters"
    >
      <b-col cols="6" class="custom-grid-row-column">
        {{ woItem.workOrderName }}
      </b-col>
      <b-col cols="2" class="custom-grid-row-column text-center">
        {{ woItem.reservedQuantity }}
      </b-col>
      <b-col cols="3" class="custom-grid-row-column text-center">
        {{ formatDate(woItem.workOrderDeliveryDate) }}
      </b-col>
      <b-col cols="1" class="custom-grid-row-column text-center">
        <b-dropdown
          dropleft
          class="card-drop"
          variant="link"
          toggle-class="text-decoration-none p-0"
          no-caret
        >
          <template #button-content>
            <i class="fas fa-ellipsis-h" />
          </template>
          <b-dropdown-item @click="requestInstead(woItem.idPublic)">
            <i class="fas fa-pen text-success mr-1"></i>
            {{ $t('items.requestInstead') }}
          </b-dropdown-item>

          <b-dropdown-item @click="cancelReservation(woItem.idPublic)">
            <i class="fas fa-trash-alt text-danger mr-1"></i>
            {{ $t('items.cancelReservation') }}
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row v-if="woItemsList.length == 0" class="custom-grid-row no-gutters">
      <b-col cols="12" class="custom-grid-row-column text-center">
        {{ $t('workOrders.noReservation') }}
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
</style>